
<v-row class="no-frame">
    <v-col class="no-frame pr-2 col-6">
        <f-read-only-field
            v-if   = "readonly"
            class  = "w-100"
            :dense = "true"
            :label = "$t('contract.dls.netamount')"
            :value = "moneyAsString(contract.unit.netamount)"
            color  = "pt-0-5 pl-1 ro-background"
        />

        <f-currency-field
            v-if      = "!readonly"
            class     = "money"
            :label    = "$t('contract.dls.netamount')"
            :readonly = "readonly"
            v-model   = "contract.unit.netamount"
            :hide-details = "true"
        />
    </v-col>
    <v-col class="no-frame pl-2 col-6">
        <f-read-only-field
            v-if   = "readonly"
            class  = "w-100"
            :dense = "true"
            :label = "$t('contract.dls.grossamount')"
            :value = "moneyAsString(contract.unit.grossamount)"
            color  = "pt-0-5 pl-1 ro-background"
        />

        <f-currency-field
            v-if      = "!readonly"
            class     = "money"
            :label    = "$t('contract.dls.grossamount')"
            :readonly = "readonly"
            v-model   = "contract.unit.grossamount"
            :hide-details = "true"
        />
    </v-col>
</v-row>
